module.exports = __webpack_public_path__ + "img/full.8a077197.png";